
import { journalsServiceApi } from "@entities/api";

interface IUpdateRequest {
  itemNoVersionId: string;
  updateSectionFourRequest: {
    mainJournalId: string;
    section4Id: string;
    section4ListId: string;
    itemPartOneId: string;
    itemPartTwo: {
      defectFixingFactDate: string;
      createOtherDocs: {
        fileMetadata: {
          fileNumber: number;
          fileName: string;
          fileType: string;
          fileContentLength: number;
          id?: string;
          fileId?: string;
        };
        file?: File;
      }[];
      defectFixingInspectionEmployeeId: string;
    };
  };
}

export async function updateSectionFourTwoRecord({
  itemNoVersionId,
  updateSectionFourRequest,
}: IUpdateRequest) {
  const formData = new FormData();

  formData.append(
    "updateRequest",
    new Blob([JSON.stringify(updateSectionFourRequest)], {
      type: "application/json",
    }),
  );

  updateSectionFourRequest.itemPartTwo.createOtherDocs?.forEach((doc) => {
    if (doc.file) {
      formData.append("otherFiles", doc.file);
    }
  });

  const res = await journalsServiceApi.putForm(
    `/journals/section-four/items/${itemNoVersionId}/partTwo`,
    formData,
  );

  return res.data;
}
